import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@material-ui/core';
import CloseIcon from "@material-ui/icons/Close";
import { LoadingIndicator } from 'Components/LoadingIndicator';
import { useFirebaseProvider } from 'Providers/FirebaseProvider';
import React, { useEffect } from 'react';
import { useAsyncTask } from 'react-hooks-async';
import { fetchPublisherDiffData } from './async';
import { PublisherDiffDialogProps } from './ShowDiffDialog.types';
import ReactDiffViewer from 'react-diff-viewer';
import stringify from 'json-stable-stringify';

const stringifyArgs = {
  space: '  '
};

export const ShowDiffDialog = ({ onClose, entry }: PublisherDiffDialogProps) => {
  const firebase = useFirebaseProvider();

  const fetchDiffTask = useAsyncTask(fetchPublisherDiffData);

  useEffect(() => {
    if (entry) {
      fetchDiffTask.start(firebase.functions, entry);
    }
    // disable error that "fetchDiffTask" isn't in dependency list (if its added it causes an infinate loop)
    // eslint-disable-next-line
  }, [entry]);

  return (<Dialog open={entry !== undefined} fullScreen={true}>
    <DialogTitle>
      <Grid container justify="space-between" alignItems="flex-start">
        <Grid item>
          <Typography variant="h3">{entry?.name}</Typography>
        </Grid>
        <Grid item>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
    </DialogTitle>
    <DialogContent>
        {fetchDiffTask.pending && <>
          <LoadingIndicator />
          <Box
            justifyContent="center"
            alignItems="center"
            display="flex"
            width="100%"
          >
            <Typography variant="h3">Loading...</Typography>
          </Box>
        </>}
        <ReactDiffViewer 
          leftTitle={fetchDiffTask.result ? "Published Post" : undefined}
          rightTitle={fetchDiffTask.result ? "Edited Post" : undefined}
          oldValue={stringify(fetchDiffTask.result?.publishedPost, stringifyArgs)}
          newValue={stringify(fetchDiffTask.result?.editPost, stringifyArgs)}
          splitView={true}
          styles={{
            line: {
              color: "grey"
            }
          }}
        />
        <Box display={"flex"} justifyContent="space-between" padding={5}>
            <Button variant="contained" color="default" onClick={onClose}>Close</Button>
        </Box>
    </DialogContent>
  </Dialog>);
};